// extracted by mini-css-extract-plugin
export default {"icon":"ErrorIcon_icon__CTOP+","tooltip":"ErrorIcon_tooltip__Zeeif"};